import { Component } from '@angular/core';

import { appVariablesProvider } from './app-variables.provider';

@Component({
  template: '<router-outlet></router-outlet>',
  providers: [appVariablesProvider],
})
export class AppVariablesProviderComponent {}
